import { useEffect } from "react";
import useQueryBoard from "./useQueryBoard";

const isDev = process.env.NODE_ENV === "development";

const useCursorVisibility = () => {
  const { data } = useQueryBoard();
  const showCursor = data?.digitalReception?.metadata?.showCursor || false;

  /**
   * We're attaching a class to disable the hidden cursor
   * directly to the body in order not to pass refs from the
   * top level component to the cursor visibility hook
   */
  useEffect(() => {
    if (isDev || showCursor) {
      document.body.classList.add("cursor-none-disabled");
      return;
    }

    document.body.classList.remove("cursor-none-disabled");
  }, [showCursor])

  return isDev || showCursor;
}

export default useCursorVisibility;